<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";

export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      agents: [],
      accounts: [],
      agent: null,
      selectedAccounts: null,
      levelThreeAccountId: null,
      levelThreeAccounts: [],
      filteredAccounts: [],
      filteredAgents: [],
      branchItem: {
        isNew: 1,
        item: {},
        code: null,
        account: null,
        Adaccount: null,
      },
      addExpense: [{}],
      reference_no: null,
      purchase_type: { code: "expenses" },
      fixed_assets: [],
      company_branches: [],
      purchase_order_types: [],
      user: {},
    };
  },
  methods: {
    selectedAgent(search) {
      this.http
        .post("agents/search", {
          search,
        })
        .then((res) => {
          if (res.status) {
            this.filteredAgents = res.data;
          }
        });
    },
    selectedAccount(search) {
      this.http
        .post("level-three-chart-of-accounts-copy-1/accounts-setup/search", {
          search,
          type: "Expense",
          level: 3,
        })
        .then((res) => {
          if (res.status) {
            this.filteredAccounts = res.data;
          }
        });
    },
    showAccountLabel(one) {
      return this.$i18n.locale == "en"
        ? one.code + " - " + one.name_en
        : one.code + " - " + one.name;
    },
    createPo() {
      console.log("step 67 :", {
        purchase_order_type: this.purchase_type,
        agent: this.agent,
        addExpense: this.addExpense,
        reference_no: this.reference_no,
      });

      this.http
        .post("purchases/purchase", {
          expenses: this.addExpense,
          agent: this.agent,
          reference_no: this.reference_no,
          purchase_order_type: this.purchase_type,
        })
        .then((res) => {
          if (res.status) {
            this.addExpense = [{}];
            this.$router.push("/payments_invoices");
          }
        });
    },
    deleteOption(index) {
      this.addExpense.splice(index, 1);
    },
    fixedAssetSearch(search) {
      this.http
        .post("fixed-assets/search", {
          search,
          page: 1,
          limit: 20,
        })
        .then((res) => {
          if (res.status) {
            this.fixed_assets = res.data;
          }
        });
    },

    showAssetLabel(one) {
      console.log("step 139 :", one);

      return this.$i18n.locale == "en" ? one.name_en : one.name;
    },
    getBranchSites(branch_id, index) {
      console.log(index);
      return new Promise((resolve) => {
        this.http
          .post("level-one-chart-of-accounts/get-branch-sites", { branch_id })
          .then((resp) => {
            console.log(resp.data);
            resolve(resp.data);
            this.addExpense[index].branch_sites = resp.data;
          });
      });
    },
    getBranches() {
      this.http.get("branches").then((res) => {
        if (res.status) this.company_branches = res.data;
      });
    },
    getPurchaseOrderTypes() {
      this.http.get("purchases/purchase-order-types").then((res) => {
        if (res.status) {
          this.purchase_order_types = res.data;
          this.purchase_type = this.purchase_order_types[0];
        }
      });
    },
    getBranchSubSites(branch_site_id, index) {
      this.addExpense[index].branch_sub_site_id = null;
      this.http
        .get("level-one-chart-of-accounts/branch-sub-sites/" + branch_site_id)
        .then((resp) => {
          this.addExpense[index].branch_sub_sites = resp.data;
        });
    },
  },
  computed: {},
  created() {
    this.getBranches();
    this.getPurchaseOrderTypes();
  },
  mounted() {
    this.user = JSON.parse(localStorage.currentUser);
    console.log("user :", this.user);
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="row align-items-center">
        <div class="d-flex align-items-center mb-4">
          <router-link :to="`/payments_invoices`">
            <h4 class="m-0">{{ $t("payments.title") }}</h4>
          </router-link>
          <div class="mx-2">\</div>
          <div>{{ $t("payments.new_payment") }}</div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <form @submit.prevent="createPo">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <label for="asset_id">{{ $t("purchases.supplier") }}</label
                  ><br />
                  <AutoCompleted
                    v-model="agent"
                    :suggestions="filteredAgents"
                    @complete="selectedAgent($event.query)"
                    :optionLabel="showAccountLabel"
                    :completeOnFocus="true"
                    class="w-100 from-control"
                    :inputClass="'w-100 from-control'"
                  />
                </div>
                <div class="col">
                  <label for="asset_id">{{ $t("popups.po_ref_no") }}</label
                  ><br />
                  <input
                    v-model="reference_no"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div>
                <div class="purchase-container">
                  <div
                    v-if="user.branch_id == 1"
                    class="row justify-content-start mb-4"
                  >
                    <div class="col-auto">
                      <div class="text-start mb-2">
                        <span class="fw-bold">
                          {{ $t("purchases.purchase_type") }}
                        </span>
                      </div>
                      <div
                        v-for="(type, index) in purchase_order_types"
                        :key="index"
                        class="form-check form-check-inline"
                      >
                        <input
                          class="form-check-input"
                          type="radio"
                          v-model="purchase_type"
                          @change="
                            addExpense = [{}];
                            addExpense = [{}];
                          "
                          id="t1"
                          :value="type"
                        />
                        <label class="form-check-label" for="t1">{{
                          $i18n.locale == "en" ? type.name_en : type.name
                        }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-10">
                      <label for="asset_id">{{
                        $t("purchases.chose_items")
                      }}</label>
                    </div>
                    <div class="col-2">
                      <button
                        type="button"
                        @click="addExpense.push({})"
                        class="btn"
                      >
                        <span
                          class="bx bxs-plus-circle fa-2x"
                          style="color: #2a3042 !important"
                        ></span>
                      </button>
                    </div>
                  </div>
                  <div v-if="purchase_type?.code == 'expenses'" class="mt-3">
                    <div v-for="(expense, index) in addExpense" :key="expense">
                      <div class="row mb-2">
                        <div class="col">
                          <AutoComplete
                            v-model="expense.search"
                            :suggestions="filteredAccounts"
                            @complete="selectedAccount($event.query)"
                            :optionLabel="showAccountLabel"
                            :completeOnFocus="true"
                            style="
                              color: #333 !important;
                              border-radius: 10px !important;
                            "
                          />
                        </div>
                        <div class="col d-flex">
                          <input
                            required
                            type="number"
                            style="margin-inline-end: 4px; display: inline"
                            v-model="expense.qty"
                            class="form-control"
                            :placeholder="$t('emps.qty')"
                          />
                          <!-- <input
                            required
                            type="number"
                            style="display: inline"
                            v-model="expense.unit_price"
                            class="form-control"
                            :placeholder="$t('emps.unit_price')"
                          /> -->
                          <currencyInput
                            required
                            v-model="expense.unit_price"
                            class="form-control"
                            :placeholder="$t('emps.unit_price')"
                          />
                        </div>
                        <div class="col">
                          <button
                            class="btn btn-sm btn-danger"
                            @click="deleteOption(index)"
                            :disabled="addExpense.length == 1"
                          >
                            <i class="bx bx-trash"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-else-if="purchase_type?.code == 'assets'"
                    class="my-2 row"
                    v-for="(asset_product, index) in addExpense"
                    :key="index"
                  >
                    <div class="col-6"></div>
                    <div class="col-6 mt-3">
                      <button
                        type="button"
                        :disabled="addExpense.length == 1"
                        @click="addExpense.splice(index, 1)"
                        class="btn btn-danger float-end"
                      >
                        <span
                          class="bx bxs-trash"
                          style="color: #fff !important"
                        ></span>
                      </button>
                    </div>
                    <div class="col-12 col-md-4">
                      <div class="form-group">
                        <label>{{ $t("fixed_assets.fixed_asset") }}</label>

                        <AutoComplete
                          v-model="asset_product.fixed_asset"
                          :suggestions="fixed_assets"
                          :complete-on-focus="true"
                          @complete="fixedAssetSearch($event.query)"
                          @item-select="
                            asset_product.fixed_asset_id =
                              asset_product.fixed_asset?.id
                          "
                          :optionLabel="showAssetLabel"
                          class="w-100"
                          :input-class="'form-control w-100'"
                          required
                        />
                      </div>
                    </div>
                    <div class="col-12 col-md-4">
                      <label for="asset_id">{{
                        $t("fixed_assets.serial_no")
                      }}</label>
                      <input
                        type="text"
                        v-model="asset_product.serial_no"
                        class="form-control mb-2 mx-1"
                        :placeholder="$t('fixed_assets.serial_no')"
                      />
                    </div>
                    <div class="col-12 col-md-4">
                      <label for="asset_id">{{
                        $t("fixed_assets.alt_name")
                      }}</label>
                      <input
                        type="text"
                        v-model="asset_product.alt_name"
                        class="form-control mb-2 mx-1"
                        :placeholder="$t('fixed_assets.alt_name')"
                      />
                    </div>
                    <div class="col-12 col-md-4">
                      <label for="asset_id">{{
                        $t("fixed_assets.alt_name_en")
                      }}</label>
                      <input
                        type="text"
                        v-model="asset_product.alt_name_en"
                        class="form-control mb-2 mx-1"
                        :placeholder="$t('fixed_assets.alt_name_en')"
                      />
                    </div>
                    <div class="col-12 col-md-4">
                      <label for="asset_id">{{ $t("emps.branch") }}</label>
                      <select
                        class="form-select"
                        v-model="asset_product.branch_id"
                        @change="getBranchSites(asset_product.branch_id, index)"
                      >
                        <option
                          v-for="branch in company_branches"
                          :key="branch"
                          :value="branch.id"
                        >
                          {{
                            $i18n.locale == "en" ? branch.name_en : branch.name
                          }}
                        </option>
                      </select>
                    </div>
                    <div class="col-12 col-md-4">
                      <div class="">
                        <label for="asset_id">{{
                          $t("fixed_assets.branch_site")
                        }}</label>
                        <select
                          class="form-select"
                          v-model="asset_product.branch_site_id"
                          @change="
                            getBranchSubSites(
                              asset_product.branch_site_id,
                              index
                            )
                          "
                        >
                          <option
                            v-for="site in asset_product.branch_sites"
                            :key="site"
                            :value="site.id"
                          >
                            {{
                              $i18n.locale == "en" ? site.name_en : site.name
                            }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-12 col-md-4">
                      <div class="">
                        <label for="asset_id">{{
                          $t("fixed_assets.branch_sub_site")
                        }}</label>
                        <select
                          class="form-select"
                          v-model="asset_product.branch_sub_site_id"
                        >
                          <option
                            v-for="site in asset_product.branch_sub_sites"
                            :key="site"
                            :value="site.id"
                          >
                            {{
                              $i18n.locale == "en" ? site.name_en : site.name
                            }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-12 col-md-4">
                      <label for="asset_id">{{
                        $t("fixed_assets.initial")
                      }}</label>
                      <currency-input
                        required
                        v-model="asset_product.initial_book_value"
                        class="form-control mb-2 mx-1"
                        :placeholder="$t('fixed_assets.initial')"
                      />
                    </div>
                    <!-- <div class="col-12 col-md-4">
                    <label for="asset_id">{{
                      $t("fixed_assets.installation_date")
                    }}</label>
                    <input
                      required
                      v-model="asset_product.installation_date"
                      type="date"
                      class="form-control"
                    />
                  </div> -->
                    <template v-if="asset_product?.fixed_asset?.depreciable">
                      <div class="col-12 col-md-4">
                        <label for="asset_id">{{
                          $t("fixed_assets.salvage_value")
                        }}</label>
                        <currency-input
                          required
                          :max="asset_product.initial_book_value"
                          v-model="asset_product.salvage_value"
                          class="form-control mb-2 mx-1"
                          :placeholder="$t('fixed_assets.salvage_value')"
                        />
                      </div>

                      <div class="col-12 col-md-4">
                        <label for="asset_id">{{
                          $t("fixed_assets.useful_life_years")
                        }}</label>
                        <input
                          type="number"
                          required
                          v-model="asset_product.useful_life_years"
                          class="form-control mb-2 mx-1"
                          :placeholder="$t('fixed_assets.useful_life_years')"
                        />
                      </div>
                    </template>
                    <div class="col-12 col-md-4">
                      <label for="asset_id">{{
                        $t("fixed_assets.replacement_cost")
                      }}</label>
                      <currency-input
                        required
                        :max="asset_product.initial_book_value"
                        v-model="asset_product.replacement_cost"
                        class="form-control mb-2 mx-1"
                        :placeholder="$t('fixed_assets.replacement_cost')"
                      />
                    </div>
                    <div class="col-12 col-md-4 align-self-center">
                      <div class="from-check form-check-inline">
                        <input
                          type="checkbox"
                          v-model="asset_product.under_warranty"
                          :id="'under_warranty-' + index"
                          class="form-check-input mx-2"
                        />
                        <label
                          class="form-check-label"
                          :for="'under_warranty-' + index"
                          >{{ $t("fixed_assets.under_warranty") }}</label
                        >
                      </div>
                    </div>

                    <div
                      class="col-12 col-md-4"
                      v-if="asset_product.under_warranty"
                    >
                      <label for="asset_id">{{
                        $t("fixed_assets.warranty_exp")
                      }}</label>
                      <input
                        required
                        v-model="asset_product.warranty_exp"
                        type="date"
                        class="form-control"
                      />
                    </div>
                    <div class="col-12 col-md-4">
                      <label for="asset_id">{{
                        $t("fixed_assets.additional_descr")
                      }}</label>
                      <textarea
                        v-model="asset_product.additional_descr"
                        class="form-control"
                      ></textarea>
                    </div>
                    <div class="col-12 col-md-4">
                      <label for="asset_id">{{
                        $t("fixed_assets.comment")
                      }}</label>
                      <textarea
                        v-model="asset_product.comment"
                        class="form-control"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="purchases-footer float-end"
                :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
              >
                <router-link to="/payments_invoices">
                  <button
                    class="btn btn-secondary"
                    style="margin-inline-end: 4px"
                  >
                    {{ $t("popups.cancel") }}
                  </button>
                </router-link>
                <button
                  type="submit"
                  :disabled="
                    !(
                      agent?.id &&
                      ((purchase_type?.code == 'expenses' &&
                        addExpense.every((expense) => expense?.search?.id)) ||
                        (purchase_type?.code == 'assets' &&
                          addExpense.every(
                            (expense) => expense?.fixed_asset?.id
                          )))
                    )
                  "
                  class="btn btn-primary"
                >
                  {{ $t("payments.create_order") }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.purchase-container {
  background: #fafafa;
  margin: 1rem;
  border-radius: 0.5rem;
  padding: 1rem;
}
.purchases-footer {
  margin: 1rem;
  border-radius: 0.5rem;
  padding: 1rem;
}
</style>
